module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjEyMDggOTA2IDI2IDI2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTMxLDcuNiwyOC40LDUsMTgsMTUuNCw3LjYsNSw1LDcuNiwxNS40LDE4LDUsMjguNCw3LjYsMzEsMTgsMjAuNiwyOC40LDMxLDMxLDI4LjQsMjAuNiwxOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDMgOTAxKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/XX.svg
// module id = t3Hs
// module chunks = 1